import React from 'react';
export function SocialProof() {
  return <section className="bg-[#0369A1] border-b-4 border-[#F97316] py-8 px-4" data-id="element-284">
      <div className="max-w-5xl mx-auto" data-id="element-285">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center divide-x divide-white/10" data-id="element-286">
          <div className="flex flex-col items-center justify-center" data-id="element-287">
            <span className="text-3xl md:text-4xl font-bold text-[#F97316] font-['Anton'] tracking-wide" data-id="element-288">
              +300
            </span>
            <span className="text-white text-sm md:text-base mt-1 font-medium" data-id="element-289">
              profes confían
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-290">
            <span className="text-3xl md:text-4xl font-bold text-[#F97316] font-['Anton'] tracking-wide" data-id="element-291">
              16+6
            </span>
            <span className="text-white text-sm md:text-base mt-1 font-medium" data-id="element-292">
              Tomos + Bonus
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-293">
            <span className="text-3xl md:text-4xl font-bold text-[#F97316] font-['Anton'] tracking-wide" data-id="element-294">
              4.9/5
            </span>
            <span className="text-white text-sm md:text-base mt-1 font-medium" data-id="element-295">
              calificación
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-296">
            <span className="text-3xl md:text-4xl font-bold text-[#F97316] font-['Anton'] tracking-wide" data-id="element-297">
              ⭐
            </span>
            <span className="text-white text-sm md:text-base mt-1 font-medium" data-id="element-298">
              🇦🇷 Argentina
            </span>
          </div>
        </div>
      </div>
    </section>;
}